import { render, staticRenderFns } from "./MspAttivitaRiepilogoCp.vue?vue&type=template&id=7996129a"
import script from "./MspAttivitaRiepilogoCp.vue?vue&type=script&lang=js"
export * from "./MspAttivitaRiepilogoCp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports